'use client'
import clsx from 'clsx'
import { useEffect } from 'react'

import { PageProvider } from '@/contexts/PageContext'
import { NormalizedConfiguration } from '@/types/Configuration'

import Header from '@/components/molecules/Header'
import Footer from '@/components/molecules/Footer'

import { PageBodyInterface } from './PageBody.types'
import styles from './PageBody.module.scss'

const PageBody = ({
  configuration,
  isHomepage = false,
  withHeader = true,
  withFooter = true,
  noMargin,
  dashboard,
  children,
  className,
  translations,
  forceTop = true,
  minified = false,
}: PageBodyInterface) => {
  useEffect(() => {
    if (forceTop && typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
      })
    }
  }, [forceTop])

  return (
    <PageProvider
      config={configuration as NormalizedConfiguration}
      isHomepage={isHomepage}
    >
      <div className={styles.shell}>
        {withHeader && (
          <Header
            isHomepage={isHomepage}
            translations={translations}
            minified={minified}
          />
        )}
        <main
          className={clsx(
            styles.main,
            dashboard && styles.dashboard,
            noMargin && styles.noMargin,
            className
          )}
        >
          {children}
        </main>
        {withFooter && <Footer />}
      </div>
    </PageProvider>
  )
}

export default PageBody
